// src/reducers/index.js
import { combineReducers } from "redux";
import commonReducer from "./commonReducer";
import productCategoryDataSlice from "../server/RequestProductCategoryList";

export const persistentRootReducer = combineReducers({
  common: commonReducer,
  productCategoryListData: productCategoryDataSlice,
});
